import { createFileRoute } from '@tanstack/react-router'
import ReportView, { ReportViewLaunchArg } from '../pages/ReportView'
import '../styles/main.css'

export const Route = createFileRoute('/reportview')({
  component: () => <ReportView />,
  validateSearch: (search: Record<string, unknown>) :ReportViewLaunchArg => {
    return {
      studyInsUid: search.studyInsUid as string,
      app: search.app as string,
      subApp: search.subApp as string,
    };
  },
})
